export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7909.790cf484.jpg";